var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiMimby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emojiMimby") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.665 4.233c6.323 0 11.466 5.283 11.466 11.774s-5.144 11.774-11.466 11.774c-2.146 0-4.24-0.616-6.058-1.778l-5.27 1.437 1.469-5.419c-1.054-1.813-1.609-3.894-1.609-6.014 0-6.492 5.144-11.774 11.466-11.774zM15.663 0.039c-8.589 0-15.551 7.149-15.551 15.968 0 2.983 0.799 5.773 2.186 8.163l-1.911 7.246 7.057-1.855c2.384 1.529 5.2 2.414 8.219 2.414 8.589 0 15.551-7.149 15.551-15.968s-6.961-15.968-15.549-15.968h-0.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.093 16.754c1.407 0 2.547-1.184 2.547-2.644s-1.14-2.644-2.547-2.644c-1.407 0-2.547 1.184-2.547 2.644s1.14 2.644 2.547 2.644z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.907 16.754c1.407 0 2.547-1.184 2.547-2.644s-1.14-2.644-2.547-2.644c-1.407 0-2.547 1.184-2.547 2.644s1.14 2.644 2.547 2.644z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.626 7.266c0 0-1.649-0.088-3.258 0.432s-2.571 1.452-2.571 1.452c0 0 1.649 0.088 3.258-0.432s2.571-1.452 2.571-1.452z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.273 7.274c0 0 1.649-0.088 3.258 0.432s2.571 1.452 2.571 1.452c0 0-1.649 0.088-3.258-0.432s-2.571-1.452-2.571-1.452z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 20.798c0 0-2.749 0.552-6.14 0.552s-6.14-0.552-6.14-0.552c0 0 2.749-0.552 6.14-0.552s6.14 0.552 6.14 0.552z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiMimby);
export default __webpack_public_path__ + "static/media/emojiMimby.7cca75127380c85894af7e67caed7cb6.svg";
export { ForwardRef as ReactComponent };